type IssueKey = string;
type ProjectKey = string;

export const extractProjectKey = (issueKey: IssueKey): ProjectKey => issueKey.split('-')[0];
